<template>
  <pg-mainshell class="detail-warp" :h1Title="data.name" v-loading="pageLoading">
    <div v-if="data != ''">
      <div class="main">
        <div class="title" v-if="data.desc.length>0">
          <h2 v-if="data.desc.length>0">接口说明</h2>
        </div>
        <div class="item-content" v-if="data.desc.length>0">
          <div>
            <img v-if="pageId == 1801 || pageId == 1802 || pageId == 1803 || pageId == 1804" style="width:auto; max-width: 100%;" src="../assets/img/flowChart.png" alt="">
            <img v-else style="width:auto; max-width: 100%;" src="../assets/img/flowChart_old.png" alt="">
          </div>
          <p class="html desc" v-html="!token && data.nodesc ? data.nodesc : data.desc">
            {{!token && data.nodesc ? data.nodesc : data.desc}}
          </p>
        </div>
        <div v-for="(item, indexApis) in data.apis" :key="item.id">
          <div class="title" v-if="(item.name || (typeof(item.statusCode)=='object'&&item.statusCode.length>0?item.statusCode[0].title:'')).length>0">
            <h1 :id="item.id" v-if="item.name && data.name !== '开发须知' && pageId != 101">
              {{item.name || (typeof(item.statusCode)=='object'&&item.statusCode.length>0?item.statusCode[0].title:'')}}
            </h1>
            <h2 v-if="item.name && data.name === '开发须知' && pageId == 101">
              {{item.name || (typeof(item.statusCode)=='object'&&item.statusCode.length>0?item.statusCode[0].title:'')}}
            </h2>
          </div>
          <div class="item-content" v-if="item.desc.length>0">
            <p class="html desc" v-html="!token && item.nodesc ? item.nodesc : item.desc">{{!token && item.nodesc ? item.nodesc : item.desc}}</p>
          </div>
          <div class="title" v-if="item.url.length>0">
              <h2>访问地址</h2>
          </div>
          <div class="item-content" v-if="item.url.length>0">
            <span class="url" v-html="item.url">
<!--              {{item.url}}-->
            </span>
          </div>
          <div class="title" v-if="item.newUrl && item.newUrl.length>0">
            <h2>3.0访问地址</h2>
          </div>
          <div class="item-content" v-if="item.newUrl && item.newUrl.length>0">
            <span class="url" v-html="item.newUrl"></span>
          </div>
          <div class="title" v-if="item.method && item.method.length>0">
              <h2>请求方式</h2>
          </div>
          <div class="item-content" v-if="item.method && item.method.length>0">
            <p v-html="item.method"></p>
          </div>
          <div v-for="(req, reqIndex) in item.request" :key="req.id" v-if="reqIndex == 0">
            <div class="title">
                <h2 :id="req.id+'_'+item.id">{{req.title}}</h2>
                <p v-if="data.loadSearchUrl"><a href="javascript:void(0)" @click="setParams(indexApis, reqIndex)" v-if="indexApis===0&&reqIndex===0 && false">设置参数</a></p>
            </div>
            <div class="item-content">
              <el-table :data="req.params" border style="width: 100%" v-if="!req.isColumnShow">
                <el-table-column
                prop="name"
                label="字段"
                width="180">
                </el-table-column>
                <el-table-column
                prop="type"
                label="类型"
                width="180">
                </el-table-column>
                <el-table-column
                  prop="fieldLength"
                  label="字段长度"
                  width="180">
                </el-table-column>
                <el-table-column
                prop="required"
                label="是否必填"
                width="180">
                </el-table-column>
                <el-table-column
                prop="desc"
                label="说明">
                  <template slot-scope="scope">
                    <div v-if="!token && scope.row.nodesc">
                      <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                      <p v-else v-html="scope.row.nodesc" class="desc" @click="handleOpenNewDrawer(scope.row.nodesc, item.statusCode, item.request)"></p>
                    </div>
                    <div v-else>
                      <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                      <p v-else v-html="scope.row.desc" class="desc" @click="handleOpenNewDrawer(scope.row.desc, item.statusCode, item.request)"></p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-table :data="codeExpTable" border style="width: 100%" v-if="req.isColumnShow">
                <el-table-column
                prop="name"
                label="字段"
                width="180">
                </el-table-column>
                <el-table-column
                prop="value"
                label="值">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.value"
                      @input="handleCodeExpTableValChange($event, scope.$index, scope.row.value)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                prop="desc"
                label="说明">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="item.reqExample.length">
            <p v-if="data.loadSearchUrl&&indexApis===0&&reqIndex===0">示例<a href="javascript:void(0)" @click="codeRun()" v-if="token">RUN</a></p>
            <p v-else>示例</p>
            <div class="item-content code" v-if="item.reqExample.length>0" v-for="(reqExp,indexReq) in item.reqExample" :key="'Req'+indexReq">
              <div style="margin-left:4px;margin-bottom:6px" v-if="reqExp.title" v-html="reqExp.title">{{reqExp.title}}</div>
<!--              <json-viewer-->
<!--                :value="JSON.parse(reqExp.code)"-->
<!--                :expand-depth=3-->
<!--                boxed-->
<!--                expanded-->
<!--                preview-mode-->
<!--                sort></json-viewer>-->
              <vue-json-pretty :data="JSON.parse(reqExp.code)"></vue-json-pretty>
            </div>
          </div>
          <el-collapse v-model="activeNames" v-for="(res, resIndex) in item.results" :key="res.id"
                       v-if="pageId == 304 || pageId == 421 || pageId == 419 || pageId == 414 || pageId == 413 || pageId == 412 || pageId == 410 || pageId == 408 || pageId == 406 || pageId == 405 || pageId == 404 || pageId == 403 || pageId == 402 || pageId == 401 || pageId == 423 || pageId == 1701"
          >
            <el-collapse-item :name="res.id":style="{ marginBottom:resIndex == item.results.length - 1 ? '0px':'-1px' }">
              <template slot="title">
                <div class="title">
                  <div v-if="res.title.indexOf('  ')>-1">
                    <div class="titChild" v-for="(tit,index_tit) in res.title.split('  ')" :key="index_tit">
                      <h2 :id="res.id+'_'+item.id" v-if="tit.indexOf('/a>')===-1">{{tit}}</h2>
                      <p v-else class="desc-h2" v-html="tit" :id="res.id+'_'+item.id" @click="findCode(tit)">{{tit}}</p>
                    </div>
                  </div>
                  <div v-else-if="res.title.indexOf(' ')>-1">
                    <div class="titChild" v-for="(tit,index_tit) in res.title.split('<a')" :key="index_tit">
                      <h2 :id="res.id+'_'+item.id" v-if="tit.indexOf('/a>')===-1">{{tit}}</h2>
                      <p v-else class="desc-h2" v-html="'<a ' + tit" :id="res.id+'_'+item.id" @click="findCode('<a ' + tit)"></p>
                    </div>
                    <div style="height:40px;display: inline-block;line-height: 40px;" v-if="token && pageId == 413 && item.id == 1 && res.id == 'result'" @click="handleExcel(pageId, item.id)">
                      <el-link type="primary" :underline="false">导出excel</el-link>
                    </div>
                  </div>
                  <div v-else class="titChild">
                    <h2 :id="res.id+'_'+item.id" v-if="res.title.indexOf('/a>')===-1">{{res.title}}</h2>
                    <h2 v-else class="desc-h2" v-html="res.title" :id="res.id+'_'+item.id" @click="findCode(res.title)">{{res.title}}</h2>
                    <div style="height:40px;display: inline-block;line-height: 40px;" v-if="token && pageId == 413 && item.id == 1 && res.id == 'result'" @click="handleExcel(pageId, item.id)">
                      <el-link type="primary" :underline="false">导出excel</el-link>
                    </div>
                  </div>
                </div>
              </template>
              <div class="item-content">
                <el-table :data="res.params" border style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="参数"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="类型"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="desc"
                    label="说明">
                    <template slot-scope="scope">
                      <div v-if="!token && scope.row.nodesc">
                        <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                        <p v-else v-html="scope.row.nodesc" class="desc" @click="findCode(scope.row.nodesc)"></p>
                      </div>
                      <div v-else>
                        <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                        <p v-else v-html="scope.row.desc" class="desc" @click="findCode(scope.row.desc)"></p>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div v-for="res in item.results" :key="res.id"
               v-if="pageId != 304 && pageId != 421 && pageId != 419 && pageId != 414 && pageId != 413 && pageId != 412 && pageId != 410 && pageId != 408 && pageId != 406 && pageId != 405 && pageId != 404 && pageId != 403 && pageId != 402 && pageId != 401 && pageId != 423 && pageId != 1701"
          >
            <div class="title">
                <div v-if="res.title.indexOf('  ')>-1">
                  <div class="titChild" v-for="(tit,index_tit) in res.title.split('  ')" :key="index_tit">
                    <h2 :id="res.id+'_'+item.id" v-if="tit.indexOf('/a>')===-1">{{tit}}</h2>
                    <p v-else class="desc-h2" v-html="tit" :id="res.id+'_'+item.id" @click="findCode(tit)">{{tit}}</p>
                  </div>
                </div>
                <div v-else class="titChild">
                  <h2 :id="res.id+'_'+item.id" v-if="res.title.indexOf('/a>')===-1">{{res.title}}</h2>
                  <h2 v-else class="desc-h2" v-html="res.title" :id="res.id+'_'+item.id" @click="findCode(res.title)">{{res.title}}</h2>
                  <div style="height:40px;display: inline-block;line-height: 40px;" v-if="token && pageId == 413 && item.id == 1 && res.id == 'result'" @click="handleExcel(pageId, item.id)">
                    <el-link type="primary" :underline="false">导出excel</el-link>
                  </div>
                </div>
            </div>
            <div class="item-content">
              <el-table :data="res.params" border style="width: 100%">
                <el-table-column
                prop="name"
                label="参数"
                width="180">
                </el-table-column>
                <el-table-column
                prop="type"
                label="类型"
                width="180">
                </el-table-column>
                <el-table-column
                prop="desc"
                label="说明">
                  <template slot-scope="scope">
                    <div v-if="!token && scope.row.nodesc">
                      <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                      <p v-else v-html="scope.row.nodesc" class="desc" @click="findCode(scope.row.nodesc)"></p>
                    </div>
                    <div v-else>
                      <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                      <p v-else v-html="scope.row.desc" class="desc" @click="findCode(scope.row.desc)"></p>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="item-content" v-for="(resExp,indexRes) in item.resExample" :key="'Res'+indexRes">
            <p>示例：</p>
            <div class="item-content code">
<!--              <json-viewer-->
<!--                :value="JSON.parse(resExp.code)"-->
<!--                :expand-depth=3-->
<!--                boxed-->
<!--                expanded-->
<!--                preview-mode-->
<!--                sort></json-viewer>-->
              <vue-json-pretty :data="JSON.parse(resExp.code)"></vue-json-pretty>
            </div>
          </div>
          <div v-for="status in item.statusCode" :key="status.id" v-if="pageId == 103 || pageId == 104 || pageId == 602 || pageId == 107 || pageId == 108">
            <div class="title">
<!--              :id="status.id+'_1'"-->
                <h2 >{{status.title}}</h2>
            </div>
            <div class="item-content">
              <el-table :data="status.params" border style="width: 100%" v-if="status.params.length>0">
                <el-table-column
                prop="name"
                label="字段"
                width="180"
                v-if="status.params[0].hasOwnProperty('name')">
                </el-table-column>
                <el-table-column
                prop="type"
                label="类型"
                width="180"
                v-if="status.params[0].hasOwnProperty('type')">
                </el-table-column>
                <el-table-column
                prop="desc"
                label="说明"
                v-if="status.params[0].hasOwnProperty('desc')">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <el-drawer id="drawer"
        :title="drawerTitle"
        :visible.sync="drawer"
        size='80%'
        :with-header="false"
        @close="drawerClose">
        <el-container>
          <el-aside v-if="searchAsideShow">
            <el-input
              v-if="filterInputShow"
              placeholder="输入关键字进行查找"
              v-model="filterText">
            </el-input>
            <ir-slider>
              <el-tree v-if="searchAsideShow"
                :props="props"
                :load="loadNode"
                lazy
                :expand-on-click-node="false"
                class="project-tree"
                :check-on-click-node="true"
                @node-click="nodeClick"
                unselectable="on"
                :filter-node-method="filterNode"
                ref="tree">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span :title="data.name">{{ data.name }}</span>
                </span>
              </el-tree>
            </ir-slider>
          </el-aside>
          <el-main>
            <h2>{{drawerTitle}}</h2>
            <el-table
              :data="codeDataNow"
              stripe
              style="width:90%;margin:0 auto"
              :height="drawerTableHeight">
              <el-table-column
                prop="chName"
                label="名称">
              </el-table-column>
              <el-table-column
                prop="enName"
                label="英文名称">
              </el-table-column>
              <el-table-column
                prop="code"
                label="码值"
                v-if="isCodeData">
                <template slot-scope="scope">
                  {{ scope.row.code }}
                </template>
              </el-table-column>
              <el-table-column
                prop="externalValue"
                label="接口对接值"
                v-if="isCodeData">
                <!-- 修改信息集 信息项 数据源 接口对接值 编辑功能 -->
                <!-- <template slot-scope="scope">
                  <p v-if="!scope.row.isEdit" style="width:90%">{{ scope.row.externalValue }}
                    <el-button type="default" size="mini" icon="el-icon-edit" @click="handleTableRowEdit('externalValue', scope.$index, scope.row)"></el-button>
                  </p>
                  <el-input v-model="scope.row.externalValue" size="mini" @blur="handleBlurSave('externalValue', scope.$index, scope.row)" v-else style="width:90%"></el-input>
                </template> -->
              </el-table-column>
              <el-table-column
                prop="dataSource"
                label="码值"
                v-if="!isCodeData">
                <template slot-scope="scope">
                  {{ scope.row.dataSource }}
                </template>
              </el-table-column>
              <el-table-column
                prop="xmlName"
                label="接口对接值"
                v-if="!isCodeData">
                <!-- 修改信息集 信息项 数据源 接口对接值 编辑功能 -->
                <!-- <template slot-scope="scope">
                  <p v-if="!scope.row.isEdit" style="width:90%">{{ scope.row.xmlName }}
                  <el-button type="default" size="mini" icon="el-icon-edit" @click="handleTableRowEdit('xmlName', scope.$index, scope.row)"></el-button>
                  </p>
                  <el-input v-model="scope.row.xmlName" size="mini" @blur="handleBlurSave('xmlName', scope.$index, scope.row)" v-else style="width:90%"></el-input>
                </template> -->
              </el-table-column>
            </el-table>
            <el-divider></el-divider>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-sizes="pagination.pagesizes" :page-size="pagination.pagesize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
            </el-pagination>
          </el-main>
        </el-container>
      </el-drawer>
      <el-drawer id="drawer2"
        :title="drawerTitle"
        :visible.sync="drawer2"
        size='50%'
        :with-header="false">
        <pg-mainshell :h1Title="drawer2Data.name">
          <div v-if="drawer2Data != ''">
            <div class="main">
              <div class="title" v-if="drawer2Data.desc.length>0">
                <h2 v-if="drawer2Data.desc.length>0">接口说明</h2>
              </div>
              <div class="item-content" v-if="drawer2Data.desc.length>0">
                <p class="html desc" v-html="!token && drawer2Data.nodesc ? drawer2Data.nodesc : drawer2Data.desc">
                  {{!token && drawer2Data.nodesc ? drawer2Data.nodesc : drawer2Data.desc}}
                </p>
              </div>
              <div v-for="(item, indexApis) in drawer2Data.apis" :key="item.id">
                <div class="title" v-if="(item.name || (typeof(item.statusCode)=='object'&&item.statusCode.length>0?item.statusCode[0].title:'')).length>0">
                  <h1 :id="item.id">
                    {{item.name || (typeof(item.statusCode)=='object'&&item.statusCode.length>0?item.statusCode[0].title:'')}}
                  </h1>
                </div>
                <div class="item-content" v-if="item.desc.length>0">
                  <p class="html desc" v-html="!token && item.nodesc ? item.nodesc : item.desc">{{!token && item.nodesc ? item.nodesc : item.desc}}</p>
                </div>
                <div class="title" v-if="item.url.length>0">
                    <h2>访问地址</h2>
                </div>
                <div class="item-content url" v-if="item.url.length>0" v-html="item.url">
<!--                    {{item.url}}-->
                </div>
                <div class="title" v-if="item.newUrl && item.newUrl.length>0">
                  <h2>3.0访问地址</h2>
                </div>
                <div class="item-content url" v-if="item.newUrl && item.newUrl.length>0" v-html="item.newUrl">
                  <!--                    {{item.url}}-->
                </div>
                <div class="title" v-if="item.method && item.method.length>0">
                    <h2>请求方式</h2>
                </div>
                <div class="item-content" v-if="item.method && item.method.length>0">
                    {{item.method}}
                </div>
                <div v-for="(req, reqIndex) in item.request" :key="req.id">
                  <div class="title">
                      <h2 :id="req.id+'_'+item.id">{{req.title}}</h2>
                      <p v-if="drawer2Data.loadSearchUrl"><a href="javascript:void(0)" @click="setParams(indexApis, reqIndex)" v-if="indexApis===0&&reqIndex===0&&false">设置参数</a></p>
                  </div>
                  <div class="item-content">
                    <el-table :data="req.params" border style="width: 100%" v-if="!req.isColumnShow">
                      <el-table-column
                      prop="name"
                      label="字段"
                      width="180">
                      </el-table-column>
                      <el-table-column
                      prop="type"
                      label="类型"
                      width="180">
                      </el-table-column>
                      <el-table-column
                        prop="fieldLength"
                        label="字段长度"
                        width="180">
                      </el-table-column>
                      <el-table-column
                      prop="required"
                      label="是否必填"
                      width="180">
                      </el-table-column>
                      <el-table-column
                      prop="desc"
                      label="说明">
                        <template slot-scope="scope">
                          <div v-if="!token && scope.row.nodesc">
                            <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                            <p v-else v-html="scope.row.nodesc" class="desc" @click="findCode(scope.row.nodesc)"></p>
                          </div>
                          <div v-else>
                            <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                            <p v-else v-html="scope.row.desc" class="desc" @click="findCode(scope.row.desc)"></p>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table :data="codeExpTable" border style="width: 100%" v-if="req.isColumnShow">
                      <el-table-column
                      prop="name"
                      label="字段"
                      width="180">
                      </el-table-column>
                      <el-table-column
                      prop="value"
                      label="值">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.value"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                      prop="desc"
                      label="说明">
                      </el-table-column>
                    </el-table>
                    <p v-if="indexApis===0&&reqIndex===0">示例<a href="javascript:void(0)" @click="codeRun()" v-if="token">RUN</a></p>
                    <div class="item-content code" v-if="indexApis===0&&reqIndex===0" v-for="(resExp,indexRes) in item.reqExample" :key="'Res'+indexRes">
                      <!-- {{req.params}} -->
<!--                      <json-viewer-->
<!--                        :value="JSON.parse(resExp.code)"-->
<!--                        :expand-depth=3-->
<!--                        boxed-->
<!--                        expanded-->
<!--                        preview-mode-->
<!--                        sort></json-viewer>-->
                      <vue-json-pretty :data="JSON.parse(resExp.code)"></vue-json-pretty>
                    </div>
                  </div>
                </div>
                <div v-for="(reqExp,indexReq) in item.reqExample" :key="'Req'+indexReq">
                  <div class="item-content code" v-if="reqExp.title.length>0">
                    <p>{{reqExp.title}}</p>
<!--                    <json-viewer-->
<!--                      :value="JSON.parse(reqExp.code)"-->
<!--                      :expand-depth=3-->
<!--                      boxed-->
<!--                      expanded-->
<!--                      preview-mode-->
<!--                      sort></json-viewer>-->
                    <vue-json-pretty :data="JSON.parse(reqExp.code)"></vue-json-pretty>
                  </div>
                </div>
                <div v-for="res in item.results" :key="res.id">
                  <div class="title">
                      <div v-if="res.title.indexOf('  ')>-1">
                        <div class="titChild" v-for="(tit,index_tit) in res.title.split('  ')" :key="index_tit">
                          <h2 :id="res.id+'_'+item.id" v-if="tit.indexOf('/a>')===-1">{{tit}}</h2>
                          <p v-else class="desc-h2" v-html="tit" :id="res.id+'_'+item.id" @click="findCode(tit)">{{tit}}</p>
                        </div>
                      </div>
                      <div v-else class="titChild">
                        <h2 :id="res.id+'_'+item.id" v-if="res.title.indexOf('/a>')===-1">{{res.title}}</h2>
                        <h2 v-else class="desc-h2" v-html="res.title" :id="res.id+'_'+item.id" @click="findCode(res.title)">{{res.title}}</h2>
                      </div>
                  </div>
                  <div class="item-content">
                    <el-table :data="res.params" border style="width: 100%">
                      <el-table-column
                      prop="name"
                      label="参数"
                      width="180">
                      </el-table-column>
                      <el-table-column
                      prop="type"
                      label="类型"
                      width="180">
                      </el-table-column>
                      <el-table-column
                      prop="desc"
                      label="说明">
                        <template slot-scope="scope">
                          <div v-if="!token && scope.row.nodesc">
                            <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                            <p v-else v-html="scope.row.nodesc" class="desc" @click="findCode(scope.row.nodesc)"></p>
                          </div>
                          <div v-else>
                            <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                            <p v-else v-html="scope.row.desc" class="desc" @click="findCode(scope.row.desc)"></p>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div class="item-content" v-for="(resExp,indexRes) in item.resExample" :key="'Res'+indexRes">
                  <p>示例：</p>
                  <div class="item-content code">
<!--                    <json-viewer-->
<!--                      :value="JSON.parse(resExp.code)"-->
<!--                      :expand-depth=3-->
<!--                      boxed-->
<!--                      expanded-->
<!--                      preview-mode-->
<!--                      sort></json-viewer>-->
                    <vue-json-pretty :data="JSON.parse(resExp.code)" ></vue-json-pretty>
                  </div>
                </div>
                <div v-for="status in item.statusCode" :key="status.id">
                  <div class="title">
                      <h2 :id="status.id+'_1'">{{status.title}}</h2>
                  </div>
                  <div class="item-content">
                    <el-table :data="status.params" border style="width: 100%" v-if="status.params.length>0">
                      <el-table-column
                      prop="name"
                      label="字段"
                      width="180"
                      v-if="status.params[0].hasOwnProperty('name')">
                      </el-table-column>
                      <el-table-column
                      prop="type"
                      label="类型"
                      width="180"
                      v-if="status.params[0].hasOwnProperty('type')">
                      </el-table-column>
                      <el-table-column
                      prop="desc"
                      label="说明"
                      v-if="status.params[0].hasOwnProperty('desc')">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </pg-mainshell>
      </el-drawer>
      <el-drawer
        v-if="statusCodeData.title"
        id="statusCodeDrawer"
        :append-to-body="true"
        :destroy-on-close="true"
        :visible.sync="statusCodeDrawerShow"
        size="40%"
        :with-header="false">
        <div class="main">
          <div class="title">
            <!--:id="status.id+'_1'"-->
            <h2 >{{statusCodeData.title}}</h2>
          </div>
          <div class="item-content">
            <el-table :data="statusCodeData.params" border style="width: 100%" v-if="statusCodeData.params.length>0">
              <el-table-column
                prop="name"
                label="字段"
                width="180"
                v-if="statusCodeData.params[0].hasOwnProperty('name')">
              </el-table-column>
              <el-table-column
                prop="type"
                label="类型"
                width="180"
                v-if="statusCodeData.params[0].hasOwnProperty('type')">
              </el-table-column>
              <el-table-column
                prop="required"
                label="是否必填"
                width="180"
                v-if="statusCodeData.params[0].required !== null && statusCodeData.params[0].required !== undefined">
              </el-table-column>
              <el-table-column
                label="说明"
                v-if="statusCodeData.params[0].hasOwnProperty('desc')">
                <template slot-scope="scope">
                  <div v-if="!token && scope.row.nodesc">
                    <p v-if="scope.row.nodesc.indexOf('/a>')===-1">{{ scope.row.nodesc }}</p>
                    <p v-else v-html="scope.row.nodesc" class="desc" @click="findCode(scope.row.nodesc)"></p>
                  </div>
                  <div v-else>
                    <p v-if="scope.row.desc.indexOf('/a>')===-1">{{ scope.row.desc }}</p>
                    <p v-else v-html="scope.row.desc" class="desc" @click="findCode(scope.row.desc)"></p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-drawer>
    </div>
  </pg-mainshell>
</template>

<script>
import PgMainshell from './PgMainShell'
import VueJsonPretty from 'vue-json-pretty'
import JsonViewer from 'vue-json-viewer'
import constant from '../utils/constant'
import IrSlider from './IrSlider'
import $ from 'jquery'
import 'vue-json-pretty/lib/styles.css'

export default {
  data () {
    return {
      pageId: '',
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      data: '',
      drawer2Data: '',
      isReqEditParams: [],
      drawer: false,
      drawer2: false, // 展示 获取token方法 和 通用状态码表
      drawerTitle: '',
      drawerTableHeight: '',
      searchAsideShow: false,
      filterText: '',
      filterInputShow: true,
      codeData: [],
      codeDataNow: [],
      isCodeData: true,
      codeArr: [],
      codeType: '',
      codeId: '',
      pagination: {
        currentPage: 1,
        pagesizes: [10],
        pagesize: 10
      },
      total: 0,
      codeExpTable: [],
      pageLoading: false,
      token: '',
      activeNames: ['result'],
      statusCodeData: {},
      statusCodeDrawerShow: false
    }
  },
  computed: {
    key () {
      return this.$route.path + '  ' + Math.random()
    }
  },
  components: {
    PgMainshell,
    VueJsonPretty,
    JsonViewer,
    IrSlider
  },
  methods: {
    initData () {
      let pathArr = this.$route.path.split('/')
      let params = {
        id: pathArr[pathArr.length - 1]
      }
      this.token = sessionStorage.getItem('token')
      this.getMenuDetailApi(false, params)
    },
    async getMenuMainData () {
      let result = []
      await this.$api.menu.MenuMainApi()
        .then(function (res) {
          result = res.data.data
        })
        .catch(function (err) {
          console.log(err)
          // constant.giveMessage('获取目录错误，请联系管理员！', 'error')
        })
      return result
    },
    // 根据目录id获取jsonFilePath
    async handleGetJsonFilePath (menuId) {
      let menuMainData = sessionStorage.getItem('menuMainData') ? JSON.parse(sessionStorage.getItem('menuMainData')) : []
      if (!sessionStorage.getItem('menuMainData')) {
        menuMainData = await this.getMenuMainData()
      }
      let jsonFilePath = ''
      menuMainData.forEach(item => {
        if (item.entityId == menuId) {
          jsonFilePath = item.jsonFilePath
        }
      })
      return jsonFilePath
    },
    async getMenuDetailApi (isdrawer, _params) {
      let that = this
      that.pageLoading = true
      if (await this.handleGetJsonFilePath(_params.id)) {
        _params.query = { jsonFilePath: await this.handleGetJsonFilePath(_params.id) }
      }
      this.$api.menu.MenuDetailApi(_params)
        .then(function (res) {
          if (res.data.data == null) {
            that.$router.push({ path: constant.pathPre + '/Home/Index' })
          } else {
            that.pageLoading = false
            if (res.data.data.loadSearchUrl !== null) {
              let arr = res.data.data.loadSearchUrl.split('?')
              let applyStatus = ''
              if (arr.length > 1) {
                let paramArr = arr[1].split('&&')
                let nparamApplyStatusList = paramArr.filter(x => x.indexOf('applyStatus=') > -1)
                applyStatus = nparamApplyStatusList[0].substring(nparamApplyStatusList[0].indexOf('applyStatus=') + 12)
              }

              let codeExp = JSON.parse(res.data.data.apis[0].reqExample[0].code)
              let id = that.$route.params.id
              // // 对于code示例的处理,四个固定参数展示
              if (parseInt(id) === 401) {
                codeExp.vType = res.data.data.vType === undefined ? '' : res.data.data.vType
              } else {
                if (codeExp.hasOwnProperty('recruitType')) {
                  codeExp.recruitType = res.data.data.recruitType === undefined ? '' : res.data.data.recruitType
                }
                if (codeExp.hasOwnProperty('vType')) {
                  codeExp.vType = res.data.data.vType === undefined ? '' : res.data.data.vType
                }
                if (codeExp.hasOwnProperty('cType')) {
                  codeExp.cType = res.data.data.cType === undefined ? '' : res.data.data.cType
                }
                if (codeExp.hasOwnProperty('applyStatus')) {
                  codeExp.applyStatus = applyStatus
                }
              }
              that.codeExp = codeExp
              for (let api in res.data.data.apis) {
                for (let req in res.data.data.apis[api].request) {
                  res.data.data.apis[api].request[req].codeExp = codeExp
                }
              }
            } else {
              let req = res.data.data.apis[0].request
              if (req.length > 0) {
                let paramsList = res.data.data.apis[0].request[0].params
                if (typeof (paramsList) !== 'undefined') {
                  let codeExp = {}
                  for (let index in paramsList) {
                    codeExp[paramsList[index].name] = paramsList[index].name === 'applyStatus' ? paramsList[index].desc.substring(paramsList[index].desc.indexOf('：') + 1) : ''
                  }

                  if (codeExp.hasOwnProperty('originResumeAttachment')) {
                    codeExp.originResumeAttachment = 0
                  }
                  if (codeExp.hasOwnProperty('rowSize')) {
                    codeExp.rowSize = '10'
                  }
                  res.data.data.apis[0].request[0].codeExp = codeExp
                }
              }
            }
            if (isdrawer) {
              that.drawer2Data = res.data.data
            } else {
              that.data = res.data.data
              res.data.data.apis.forEach(item => {
                if (Array.isArray(item.results)) {
                  item.results.forEach(rItem => {
                    that.activeNames.push(rItem.id)
                  })
                }
              })
            }
          }
          setTimeout(() => {
            $('.anchorPointClick').on('click', function () {
              that.activeNames.push($(this).attr('data-anchorpoint'))
            })
          }, 300)
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    setParams (indexApis, index) {
      let tmp = this.data.apis[indexApis].request[index]
      if (this.data.apis[indexApis].request[index].isColumnShow === undefined) {
        this.data.apis[indexApis].request[index].isColumnShow = true
        tmp = this.data.apis[indexApis].request[index]
      } else {
        this.data.apis[indexApis].request[index].isColumnShow = !this.data.apis[indexApis].request[index].isColumnShow
        tmp = this.data.apis[indexApis].request[index]
      }
      this.data.apis[indexApis].request.splice(index, 1, tmp)
      this.codeExpTable.splice(0, this.codeExpTable.length)

      let codeExpTableTmp = this.data.apis[0].request[0].params.filter(x => x.name === 'cType' || x.name === 'vType')
      for (let item in codeExpTableTmp) {
        let items = codeExpTableTmp[item]
        items.value = ''
        this.codeExpTable.push(items)
      }
    },
    codeRun () {
      let id = this.$route.params.id
      let codeExp = {}

      let cTypeList = this.codeExpTable.filter(x => x.name === 'cType')
      let vTypeList = this.codeExpTable.filter(x => x.name === 'vType')
      if (cTypeList.length > 0) {
        codeExp.cType = cTypeList[0].value
      }
      if (vTypeList.length > 0) {
        codeExp.vType = vTypeList[0].value
      }
      let params = {
        id: id,
        query: codeExp
      }
      this.getMenuDetailApi(false, params)
    },
    findCode (descAll) {
      let typeIs123 = descAll.indexOf("type='1") > -1 || descAll.indexOf("type='2") > -1 || descAll.indexOf("type='3") > -1
      if (descAll.indexOf('<a') > -1 && typeIs123 && descAll.indexOf('id') > -1) {
        let typeIndex = descAll.indexOf("type='")
        let idIndex = descAll.indexOf("' id='")
        let type = descAll.substring(typeIndex + 6, idIndex)
        let idStr = descAll.substring(idIndex + 6)
        let id = idStr.substring(0, idStr.indexOf("'>"))
        this.currentNodeKey = id.substring(id, id.length - 1)
        this.codeType = type
        if (parseInt(type) === 2) {
          this.drawerTitle = '信息集'
        }
        if (parseInt(type) === 3) {
          this.drawerTitle = '信息项'
        }
        let txt = descAll.substring(descAll.indexOf("'>") + 2, descAll.indexOf('</a>'))

        if (descAll.indexOf('数据源') > -1 || descAll.indexOf('码表') > -1) {
          this.searchAsideShow = true// 左侧树是否展示
          // this.tableDataChange = descAll.indexOf('码表') > -1
          this.tableDataChange = true// 表是否跟随树变动
          this.drawerTitle = '数据源'
          if (descAll.indexOf('码表') > -1) {
            this.drawerTitle = descAll.substring(0, descAll.indexOf('<a') - 1)
            this.filterInputShow = false
          } else {
            this.codeArr.push(id)
          }
        }

        if (txt.indexOf(' ') > -1) {
          let txtArr = txt.split(' ')
          if (txt.indexOf('/') > -1) {
            let codeArr = txtArr[0].split('/')
            this.codeArr = codeArr
          }
        }
        this.codeId = id
        this.getInfoApi(type, id)
        this.drawer = true
      }
    },
    getInfoApi (type, id) {
      let that = this
      this.$api.menu.InfoApi(type, id)
        .then(function (res) {
          // this.drawerTitle =
          // 数据源type=1 和 信息项3信息集2不同
          if (parseInt(type) === 1) {
            that.isCodeData = true
            that.total = res.data.data.total
            if (res.data.data != null) {
              // 所有数据
              that.codeData = res.data.data.list
              that.codeDataNow = that.codeData.filter((x, index) => index >= 0 * that.pagination.pagesize && index < that.pagination.pagesize)
            }
          } else {
            that.isCodeData = false
            if (parseInt(res.data.data.total) > parseInt(that.total)) {
              that.total = res.data.data.total
            }
            if (res.data.data != null) {
              if (that.codeDataNow.length > 0) {
                that.codeDataNow = that.codeDataNow.splice(0, that.codeDataNow.length)
              }
              // 当前数据
              that.codeDataNow = res.data.data.list
            }
          }
        })
        .catch(function (err) {
          console.log(err)
          constant.giveMessage('Error！', 'error')
        })
    },
    handleSizeChange (val) {
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      if (parseInt(this.codeType) === 1) {
        // type=1数据源筛选
        this.codeDataNow.splice(0, this.codeDataNow.length)
        this.codeDataNow = this.codeData.filter((x, index) => index >= (parseInt(val) - 1) * this.pagination.pagesize && index < parseInt(val) * this.pagination.pagesize)
      } else {
        // type=2,3数据重新请求
        this.codeDataNow.splice(0, this.codeDataNow.length)
        let codeArr = this.codeId.split(',')
        let codeArr0 = codeArr[0]
        // 过滤第一个
        codeArr = codeArr.filter((x, index) => index > 0)
        let codeArrNow = codeArr.filter((x, index) => index >= (parseInt(val) - 1) * this.pagination.pagesize && index < parseInt(val) * this.pagination.pagesize)
        let idStr = ''
        for (let id in codeArrNow) {
          idStr = idStr + codeArrNow[id] + ','
        }
        idStr = idStr.substring(0, idStr.length - 1)
        idStr = codeArr0 + ',' + idStr
        this.getInfoApi(this.codeType, idStr)
      }
    },
    loadNode (node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.requestTree(resolve)
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getIndex(node, resolve)
      }
    },
    // 异步加载叶子节点数据函数
    getIndex (node, resolve) {
      // this.drawerTitle = node.label

      if (this.tableDataChange) {
        this.drawerTitle = node.label
        this.getInfoApi(this.codeType, node.data.entityId)
      }
      if (this.codeArr.length > 0) {
        // this.$api.menu.InfoApi(this.codeType, node.data.entityId)
        this.$api.menu.loadChildrenApi(node.data.entityId)
          .then(function (res) {
            let dataInfo = []
            let list = res.data.data
            if (list.length > 0) {
              for (let item in list) {
                let tmpP = {
                  entityId: list[item].entityId,
                  level: 2,
                  name: list[item].chName,
                  leaf: false
                }
                dataInfo.push(tmpP)
              }
              resolve(dataInfo)
            } else {
              resolve([])
            }
          })
          .catch(function (err) {
            console.log(err)
            constant.giveMessage('Error！', 'error')
          })
      }
    },
    // 首次加载一级节点数据函数
    requestTree (resolve) {
      let that = this
      if (this.codeArr.length > 0) {
        this.$api.menu.InfoApi(this.codeType, this.codeArr[0])
          .then(function (res) {
            let dataInfo = []
            let list = res.data.data.list
            if (that.codeArr[0].indexOf('-1') === -1) {
              list = list.filter(x => x.entityId === parseInt(that.codeArr[1]))
            }
            for (let item in list) {
              let tmpP = {
                entityId: list[item].entityId,
                level: 1,
                name: list[item].chName,
                leaf: false
              }
              dataInfo.push(tmpP)
            }
            resolve(dataInfo)
          })
          .catch(function (err) {
            console.log(err)
            constant.giveMessage('Error！', 'error')
          })
      }
    },
    nodeClick (data, node, self) {
      this.pagination.currentPage = 1
      if (this.tableDataChange) {
        this.drawerTitle = node.label
        this.getInfoApi(this.codeType, node.data.entityId)
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    drawerClose () {
      // 初始化所有数据
      this.codeDataNow.splice(0, this.codeDataNow.length)
      this.codeData.splice(0, this.codeData.length)
      this.codeArr.splice(0, this.codeArr.length)
      this.total = 0
      this.codeType = ''
      this.codeId = ''
      this.searchAsideShow = false
      this.dataSourse = false
      this.drawerTitle = ''
      this.filterInputShow = true
    },
    handleTableRowEdit (name, index, row) {
      let tmp = this.codeDataNow[index]
      if (typeof (this.codeDataNow[index].isEdit) === 'undefined') {
        tmp.isEdit = true
      } else {
        tmp.isEdit = !row.isEdit
      }
      this.codeDataNow.splice(index, 1, tmp)
    },
    handleCodeExpTableValChange (e, id, val) {
      this.$forceUpdate()
      let item = this.codeExpTable[id]
      item.value = val
      this.codeExpTable.splice(id, 1, item)
    },
    handleBlurSave (name, index, row) {
      this.handleTableRowEdit(name, index, row)
      let that = this
      let entityId, params
      switch (name) {
        case 'externalValue':
          entityId = that.codeDataNow[index].entityId
          params = that.codeDataNow[index].externalValue
          that.$api.infoItem.saveUpdateDataSourceApi(entityId, params)
            .then(function (res) {
              constant.giveMessage('保存成功！', 'success')
            })
            .catch(function (err) {
              console.log(err)
              constant.giveMessage('Error！', 'error')
            })
          break
        case 'xmlName':
          entityId = that.codeDataNow[index].entityId
          params = that.codeDataNow[index].xmlName
          if (parseInt(that.codeType) === 2) {
            this.$api.infoItem.saveUpdateInfoClassListApi(entityId, params)
              .then(function (res) {
                constant.giveMessage('保存成功！', 'success')
              })
              .catch(function (err) {
                console.log(err)
                constant.giveMessage('Error！', 'error')
              })
          } else {
            this.$api.infoItem.saveUpdateInfoItemListApi(entityId, params)
              .then(function (res) {
                constant.giveMessage('保存成功！', 'success')
              })
              .catch(function (err) {
                console.log(err)
                constant.giveMessage('Error！', 'error')
              })
          }
          break
        default:
          break
      }
    },
    // 导出excel
    handleExcel (id, interfaceId) {
      let url = `/apis/wtapi/api/export/${id}?interfaceId=${interfaceId}&token=${this.token}`
      window.open(url)
    },
    // 请求接口方式打开抽屉
    handleOpenNewDrawer (desc, statusCode, reqList) {
      if (desc.indexOf("href='#") > -1) {
        let id = desc.split("href='#")[1].split('_1')[0]
        statusCode.forEach(item => {
          if (item.id == id) {
            this.statusCodeData = item
            this.statusCodeDrawerShow = true
          }
        })
        reqList.forEach((item, index) => {
          if (index != 0 && item.id == id) {
            this.statusCodeData = item
            this.statusCodeDrawerShow = true
          }
        })
      } else {
        this.findCode(desc)
      }
    }
  },
  created: function () {
    this.pageId = this.$route.params.id
    this.initData()
    this.drawerTableHeight = parseInt(window.innerHeight) - 60 - 50 - 100 - 70 + 'px'
    // 上60下150标题50  父级padding上下35
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  updated: function () {
    let that = this
    this.pathPre = this.$route.path
    $('.desc').find('a').css({'color': '#1890FF', 'cursor': 'pointer'})
    $('.desc-h2').find('a').css({
      'cursor': 'pointer',
      'height': '20px',
      'line-height': '20px',
      'text-align': 'left',
      'font-size': '14px',
      'font-family': 'Microsoft YaHei',
      'color': '#1890FF',
      'display': 'inline-block',
      'padding': '0 4px'
    })
    $('.titChild').css('display', 'inline-block')
    $('.titChild').find('h2').css('height', 'fit-content')
    $('.el-tree').css({
      'height': parseInt(window.innerHeight) - 70 - 40 - 15 + 'px' // 70上下padding之和，40el-input搜索框
      // 'overflow-y': 'scroll',
      // 'overflow-x': 'hidden'
    })

    $('#getToken').unbind().click(function () {
      let params = {
        id: 102
      }
      that.getMenuDetailApi(true, params)
      that.drawer2 = true
    })
    $('#currencyState').unbind().click(function () {
      let params = {
        id: 103
      }
      that.getMenuDetailApi(true, params)
      that.drawer2 = true
    })
    $('.getToken').unbind().click(function () {
      let params = {
        id: 102
      }
      that.getMenuDetailApi(true, params)
      that.drawer2 = true
    })
    $('.currencyState').unbind().click(function () {
      let params = {
        id: 103
      }
      that.getMenuDetailApi(true, params)
      that.drawer2 = true
    })
  }
}
</script>
<style>
.main .jv-container .jv-more {
  display: none;
}
.main .el-collapse-item__header,
.main .el-collapse-item__wrap{
  border-bottom: none!important;
}
</style>
<style scoped>
.main{
    text-align: left;
    padding: 36px 48px;
    background: #fff;
}
.title,h2{
    line-height: 20px;
}
.main .title h1{
  height: 33px;
  text-align: left;
  font: Bold 24px/21px Microsoft YaHei;
  letter-spacing: 0;
  color: rgba(0,0,0,.85);
  /*padding-bottom: 20px;*/
}
.main .title h2{
    height: 20px;
    line-height: 20px;
    text-align: left;
    font-size: 20px;
    font-family: Microsoft YaHei;
    letter-spacing: 0;
    color: rgba(0, 0, 0, .85);
    padding: 0 6px 0 12px;
    border-left: 4px solid #354ECE;
    font-weight: 400;
    display: inline-block;
    margin-top:10px;
}
p{
  line-height: 20px;
  text-align: left;
  color:rgba(0,0,0,.85);
}
.main .title p{
    height: 20px;
    line-height: 20px;
    text-align: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    color: #1890FF;
    display: inline-block;
    padding: 0 4px;
}
p.html{
  height: auto !important;
}
.main .title p>a{
    color: #1890FF;
}
.main .item-content{
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    letter-spacing: 0;
    color: #8FA1B7;
    opacity: 1;
    line-height: initial;
    line-height: normal;
    padding: 16px 0 36px 16px;
}
.main .item-content>p{
    width: 100%;
    height: 20px;
    text-align: left;
    font: 16px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: rgba(0,0,0,.65);
    padding: 16px 0 8px 0;
}
.main .item-content>p>a{
    width: 30px;
    height: 14px;
    text-align: left;
    text-decoration: underline;
    font: 16px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: #1890FF;
    opacity: 1;
    padding-left: 12px;
}
.code{
    width: 100%;
    background: #FAFBFC 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    margin-bottom: 15px;
}
.main .url{
    color: #1890FF !important;
}
/* 可编辑表格的实现 （样式）*/
.tb-edit .input-box {
   display: none
}
.tb-edit .current-cell .input-box {
   display: block;
   margin-left: -15px;
}

#drawer /deep/ .el-container{
  padding: 35px;
}
#drawer /deep/ h2
{
  width: 100%;
  height: 37px;
  padding-left: 45px;
  padding-bottom: 15px;
  text-align: left;
  font: Bold 26px/21px Microsoft YaHei;
  letter-spacing: 0px;
  color: #445870;
  opacity: 1;
}
#drawer /deep/ .el-aside,
#drawer /deep/ th{
  line-height: normal;
}
#drawer /deep/ .el-aside{
  width: 170px !important;
  height: calc(100% - 70px - 40px);
}

#drawer /deep/ .el-scrollbar{
  height: calc(100% - 40px)
}
#drawer /deep/ .el-scrollbar__wrap{
  margin-bottom: 0 !important;
  background: #fff !important;
}
#drawer /deep/ .el-tree{
  padding-top: 15px
}

#drawer /deep/ .el-aside .el-tree>.el-tree-node>.el-tree-node__content>.custom-tree-node>span
{
  width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  display: block;
}
#drawer /deep/ .el-aside .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__content>.custom-tree-node>span
{
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
  display: block;
}

  #drawer /deep/ .el-tree>.el-tree-node>.el-tree-node__content>.custom-tree-node>span{
    width: 100%;
    height: 20px;
    text-align: left;
    font: 14px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: #445870;
    opacity: 1;
    display: block;
    padding: 8px 0;
  }
  #drawer /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__content>.custom-tree-node>span{
    width: 100%;
    height: 20px;
    text-align: left;
    font: 14px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: #445870;
    opacity: 0.9;
    padding: 8px 0;
  }
  #drawer /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__children .el-tree-node .el-tree-node__content .custom-tree-node span{
    width: 28px;
    height: 20px;
    text-align: left;
    font: 14px/19px Microsoft YaHei;
    letter-spacing: 0;
    color: #8FA1B7;
    opacity: 0.9;
    padding: 8px 0;
  }
  #drawer /deep/ .el-tree-node__content{
    padding: 8px 0;
    height: 20px;
  }

#drawer2 /deep/ .el-drawer__body{
  height: 100%;
  background: #f7f8f9;
  overflow: hidden;
}
#drawer2 .body-content{
  width: 100%;
  height: 100%;
}
#drawer2 /deep/ .el-scrollbar__view{
  height: auto;
}

header{
  display:flex;
  padding-left: 60px;
  padding-top: 20px;
  align-items: center;
}
main{
  height: calc(100% - 60px - 150px);
}
footer{
  height: 140px !important;
  width: 40%;
  position: fixed;
  bottom: 0;
  right: 0;
}

/* json格式化超出 */
.vjs-value,
.vjs-tree {
    display: inline-block;
    word-break: break-all;
}

.el-tree /deep/ .custom-tree-node{
  line-height: normal;
}

</style>



// WEBPACK FOOTER //
// src/components/PgApiDetail.vue